<div class="mat-mdc-dialog-title" data-test="dialog">
  <div class="flex flex--row flex--nowrap flex--justify-center">
    <div class="flex--column flex--justify-center">
      @if (data.title) {
        <div class="dialog__title text--bold">
          {{ data.title || '' | translate }}
        </div>
      }
      @if (data.subTitle) {
        <div class="dialog__subtitle text--small text--gray">
          {{ data.subTitle || '' | translate }}
        </div>
      }
    </div>
    @if (!data.disableClose) {
      <button
        type="button"
        mat-icon-button
        (click)="data.dialogCancelDefault ? confirm.emit() : cancel.emit(); close.emit()"
        data-test="dialog-close"
        class="dialog__close flex__child--none"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </div>
</div>
<div
  class="mat-mdc-dialog-content"
  [class.mat-mdc-dialog-content--no-spacing]="!contentSpacing"
  [class.mat-mdc-dialog-content--vertical-spacing]="verticalSpacing"
>
  <ng-content></ng-content>
</div>
<div class="mat-mdc-dialog-actions" data-test="dialogButtons">
  <div class="dialog-actions-wrapper">
    <div class="dialog-actions-group">
      @if (!data.disableClose && data.cancelButton !== false) {
        <button
          type="button"
          data-test="dialog-cancel"
          mat-button
          [disabled]="data.disableCancelButton"
          (click)="data.dialogCancelDefault ? confirm.emit() : cancel.emit()"
        >
          {{ data.dialogCancelDefault ? data.confirmButtonText : data.cancelButtonText }}
        </button>
      }
    </div>
    <div class="dialog-actions-group">
      @if (data.altButton) {
        <button
          type="button"
          data-test="form-dialog-alt"
          mat-button
          [disabled]="data.disableAltButton"
          [color]="data.altButtonColor"
          (click)="alt.emit()"
        >
          {{ data.altButtonText }}
        </button>
      }
      @if (data.dialogSubmitWarningMessage) {
        <div class="import-disabled-message">
          {{ data.dialogSubmitWarningMessage }}
        </div>
      }
      @if (data.confirmButton) {
        <button
          type="submit"
          data-test="dialog-submit"
          mat-flat-button
          [disabled]="data.disableConfirmButton"
          [color]="data.confirmButtonColor"
          (click)="data.dialogCancelDefault ? cancel.emit() : confirm.emit()"
          cdkFocusInitial
        >
          {{ data.dialogCancelDefault ? data.cancelButtonText : data.confirmButtonText }}
        </button>
      }
    </div>
  </div>
</div>
